import { NoteInfo } from './note-info';

export class Note {
  'created_at': string;
  'description': string;
  'horse': Horse;
  'horse_id': number;
  'id': number;
  'date': string;
  'title': string;
  'type': string;
  'updated_at': string;
  'user': User;
  'user_id': number;
  'weight': any;
  'src': any;
  'srcs': any[];
  'images': Array<any>;
  'info'?: NoteInfo;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/note.ts